module.exports = __webpack_public_path__ + "img/xinwen7.a79294cc.jpg";